module.exports = __webpack_public_path__ + "img/Katze.a29ff37e.jpg";